import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import axios from 'axios';
import { CONSTANTS } from '../../constants';
import { Api } from './api';
var dataPumpInstance = axios.create({
  baseURL: CONSTANTS.APP.DP_HOST,
  timeout: CONSTANTS.API.OPTIONS.TIMEOUT
});
export var DataPumpAPI =
/*#__PURE__*/
function (_Api) {
  _inherits(DataPumpAPI, _Api);

  function DataPumpAPI(endpoint, auth) {
    var _this;

    _classCallCheck(this, DataPumpAPI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataPumpAPI).call(this, endpoint, auth));
    _this.endpoint = endpoint;
    return _this;
  }

  _createClass(DataPumpAPI, [{
    key: "get",
    value: function get(config) {
      return dataPumpInstance.get(this.getURL(), this.getConfig(config));
    }
  }, {
    key: "post",
    value: function post(data, config) {
      return dataPumpInstance.post(this.getURL(), data, this.getConfig(config));
    }
  }, {
    key: "put",
    value: function put(data, config) {
      return dataPumpInstance.put(this.getURL(), data, this.getConfig(config));
    }
  }, {
    key: "delete",
    value: function _delete(config) {
      return dataPumpInstance.delete(this.getURL(), this.getConfig(config));
    }
  }]);

  return DataPumpAPI;
}(Api);